export default __webpack_public_path__ + "static/fanduel-logo-6cb7f2982015dc9ea0b6aca839f4d306.png";